import { PARTICIPANT_PREFIX } from 'constants/twilio';
import { PlainTextMessage } from 'routes/Chat/Messages/PlainTextMessage';
import TextMessageWithUrl from 'routes/Chat/Messages/TextMessageWithUrl/TextMessageWithUrl';
import { FormattedMessagesType } from 'routes/Chat/Messages/types';
import { Sanitized } from 'utils/sanitize';
import { containsUrl } from 'utils/url';

export type TUnformattedTextMessage = {
  message: FormattedMessagesType;
};

/**
 * This is the legacy flow before Engine added the `textFormat` property to messages.
 * If `textFormat` is not given, the legacy flow will be used.
 * @returns
 */
export const LegacyTextMessage = ({ message }: TUnformattedTextMessage) => {
  const { index, author, text } = message;
  if (!text) return null;

  const isCustomerMsg = author.includes(PARTICIPANT_PREFIX.CUSTOMER);

  const hasUrl = containsUrl(text);
  const embeddedUrlMsg = hasUrl.result && !isCustomerMsg;
  const align = isCustomerMsg ? 'right' : 'left';

  return (
    <>
      {embeddedUrlMsg && (
        <TextMessageWithUrl align={align} hasTopGutter={false} key={index} text={text} />
      )}

      {!embeddedUrlMsg && (
        <PlainTextMessage
          align={align}
          hasTopGutter={false}
          key={index}
          text={isCustomerMsg ? text : <Sanitized text={text} />}
        />
      )}
    </>
  );
};
